import { createTheme,ThemeOptions } from "@mui/material";
// import { customization,colors } from "../config";
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    sideBarColor: {
      main: string;
      dark: string;
      light: string;
      contrastText: string;
      A100: string;
    };
  }
  interface PaletteOptions {
    sideBarColor?: {
      main?: string;
      dark?: string;
      light?: string;
      contrastText?: string;
      A100?: string;
    };
  }
}

const baseFontSize = 30;
const baseViewportWidth = 1440;
const minFontSize = 12;
const maxFontSize = 18;

const devicePixelRatio = window.devicePixelRatio || 1;
const viewportWidth = Math.min(window.innerWidth, window.outerWidth);
const scaleFactor = viewportWidth / baseViewportWidth;
let htmlFontSize = baseFontSize * scaleFactor * devicePixelRatio;
htmlFontSize = Math.max(minFontSize, Math.min(htmlFontSize, maxFontSize));

console.log(`scaleFactor ------- ${scaleFactor}`);
console.log(`viewportWidth ------- ${viewportWidth}`);
console.log(`devicePixelRatio ------- ${devicePixelRatio}`);
console.log(`baseFontSize ------- ${baseFontSize}`);
console.log(`htmlFontSize ------- ${htmlFontSize}`);



const theme = (theme:ThemeOptions)=>{
  return createTheme({
       ...theme,
       typography:{
         ...theme.typography,
         htmlFontSize
       }
  });
}
export default theme;

